import { fromFetch } from "rxjs/fetch";
import { catchError, of, switchMap } from "rxjs";
import {authStore} from "../authStore";

export async function getSystemFormId() {
  try {
    const req = await fetch(`${process.env.API_URL}/api/forms/system-forms`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${authStore.token.value}`
      },
    }).then((res) => res.json());
    console.log("SYSTEM FORM FETCH RESULT",req);
    return req;
  } catch (err) {
    console.log(err);
  }
}

export function getRawSystemFormId() {
  return fromFetch(`${process.env.API_URL}/api/forms/system-forms`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${authStore.token.value}`
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        // OK return data
        return response.json();
      } else {
        // Server is returning a status requiring the client to try something else.
        return of({ error: true, message: `Error ${response.status}` });
      }
    }),
    catchError((err) => {
      // Network or other error, handle appropriately
      console.error(err);
      return of({ error: true, message: err.message });
    })
  );
}

/*
{"founder-mentoring-feedback":"65ee0f328c63d434946c618c",
"mentor-mentoring-feedback":"65ee0f328c63d434946c618e",
"extra-mentoring-request":"65ee0f328c63d434946c6190",
"report-bug":"65ee0f328c63d434946c6192",
"suggest-feature":"65ee0f328c63d434946c6194"}
*/
